import React from 'react'
import { Link } from 'react-router-dom';
import NoResults from '../../../../components/NoResults/NoResults'

export default function RecipesTable({
  recipes,
  openForm,
  API_URL,
  sampleProduct,
  sortBy = "none",
  handleHeaderSort = () => {},
}) {
  const getSortState = () => {
    const [field, dir] = String(sortBy || "").split("|");
    return { field, dir: (dir || "").toUpperCase() };
  };

  const sortState = getSortState();

  const arrow = (field) => {
    if (sortState.field !== field) return "";
    return sortState.dir === "ASC" ? " ▲" : " ▼";
  };

return (
    <div className='border'>
      <div className='custom-scroll overflow-auto' style={{ maxHeight: "calc(100vh - 170px)" }}>
        <table className="table table-striped">
          <thead className="headers-stick-machines">
            <tr className='text-center headers-color'>
              <th className="p-2 align-middle" style={{width: "50px"}}></th>
              <th style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("EAN")}>EAN{arrow("EAN")}</th>
              <th style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("Name")}>Nazwa{arrow("Name")}</th>
              <th style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("IsActive")}>Aktywna{arrow("IsActive")}</th>
              <th style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("VATCode")}>VAT{arrow("VATCode")}</th>
              <th style={{ cursor: "pointer", userSelect: "none" }} onClick={() => handleHeaderSort("DepositName")}>Kaucja{arrow("DepositName")}</th>
              <th className="p-2 align-middle" style={{width: "90px"}}>
                <div className="d-flex flex-column align-items-center">
                  <i className="btn btn-outline-primary fas fa-plus" onClick={openForm}/>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {recipes.map((recipe) => (
              <tr key={recipe.RecipeId} className="text-center">
                <td>
                  <img src={`${API_URL}/${recipe.Image}`} onError={(evt) =>(evt.target.src = sampleProduct)} alt={recipe.Name} width="48px" height="48px"/>
                </td>
                <td>{recipe.EAN}</td>
                <td>{recipe.Name}</td>
                <td>
                  <i className={recipe.IsActive ? "fas fa-check-square text-primary" : "far fa-square text-primary"}/>
                </td>
                <td>{recipe.VATName}</td>
                <td>{recipe.DepositName}</td>
                <td className="text-right">
                  <Link to={`recipe/${recipe.RecipeId}`} className="btn btn-outline-primary btn-sm">
                    Edytuj
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {recipes?.length === 0 && <NoResults/>}
      </div>
    </div>
  );
}